import { useBankContext, useBrandContext } from '../../dictionaries/context/BankContext';
import { useCountryContext } from '../../dictionaries/context/CountryContext';
import { BankType } from '../../generated/graphql';
import { SpaceContext } from '../types/SpaceContext';

export type UseSpaceContext = Partial<SpaceContext>;

export const useSpaceContext = (
  context: UseSpaceContext,
): SpaceContext => {
  const { outDebt, ...rest } = context;
  const [ bank ] = useBankContext();
  const [ brand ] = useBrandContext();
  const [ country ] = useCountryContext();

  // space implementation
  return {
    bank: outDebt?.bank || bank! as BankType,
    brand: outDebt?.brand || brand!,
    country: outDebt?.country || country!,
    outDebt,
    ...rest,
  };
};
